import "./TreeInsights.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TreeHealthInsights from "./sections/TreeHealthInsights";
import CommonQuestions from "./sections/CommonQuestions";
import StayInformed from "./sections/StayInformed";
import SiteFooter from "@/reusable_sections/Footer";
export default function TreeInsightsPage() {
  return <div>
      <MainNavigation />
      <TreeHealthInsights />
      <CommonQuestions />
      <StayInformed />
      <SiteFooter />
    </div>;
}